import type { Prototype } from "../prototype-types";

export const maxVanostrilloPrototypes: Prototype[] = [
  {
    id: "fs-minimum-indicators",
    name: "Faire Source Minimum Indicators",
    path: "/mv/fs-minimum-indicators",
    description:
      "A production-faithful product tile row that compares the current Faire Source badge, inline shared-minimum copy, and an interactive badge explanation.",
    owner: "Max",
    createdAt: "2026-07-29",
    lastUpdated: "2026-07-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.faire.com/fastly/79db4fed539ddb087f29b02fe91e661e0e246f684529eefeaf4a2570f43781cf.png",
  },
  {
    id: "fs-shop-haul",
    name: "Faire Source Shop: Haul-Style Category Nav",
    path: "/mv/fs-shop-haul",
    description:
      "Faire Source shop page reimagined as a store-within-a-store (Amazon Haul reference): persistent category navigation with a live $100 minimum meter in the header, value-prop ticker, category tiles, an under-$12 minimum-builders carousel, and promo tiles inline in the grid. Two nav variants: flat category bar vs. mega dropdown.",
    owner: "Max",
    createdAt: "2026-07-09",
    lastUpdated: "2026-07-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.faire.com/fastly/f9fc62a7d8906da070ad8b7e8739375e1ebd0faecbe9ffa1a64e4237d330532f.png",
  },
  {
    id: "catalog-health-view",
    name: "Catalog Health View",
    path: "/mv/catalog-health-view",
    description:
      "Brand portal catalog health mockup for FbF forward coverage, at-risk SKUs, replenishment recommendations, and storage-budget-aware restock planning.",
    owner: "Max",
    createdAt: "2026-05-07",
    lastUpdated: "2026-05-07",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2be55083bc1dc7468f68a406b9c9dcaecbbabe5734a7cfe3a082dd874822b6dc.png",
    creationTool: "cursor",
  },
  {
    id: "fbf-fbb-order-flip",
    name: "FbF to FbB Order Flip",
    path: "/mv/fbf-fbb-order-flip",
    description:
      "Brand portal order acceptance prototype for moving an eligible Fulfilled by Faire brand order to Fulfilled by Brand before acceptance. Shows the default whole-brand-order self-serve path, monthly limit guardrail, reason capture, estimated reimbursement / payout impact, and structured Support handoff for post-acceptance or partial-order exceptions.",
    owner: "Max",
    createdAt: "2026-04-30",
    lastUpdated: "2026-04-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/671288065a6bcce596d08e701e8585fa5584e7a49cf69f86d640ff83b62df146.png",
    creationTool: "cursor",
  },
  {
    id: "fulfillment-product-add-ons",
    name: "Fulfillment Product Add-Ons",
    path: "/mv/fulfillment-product-add-ons",
    description:
      "Brand portal Products page with two ways to expose add-ons: (V1) a dedicated Add-ons tab with summary cards and a rule-aware table, or (V2) the right-hand filter rail with a new Add-on mode filter that swaps the table into an add-on view. Shared across both: an Add-on behavior section in the product editor that turns testers, inserts, and free-with-purchase items into one primitive — a product that can be non-shoppable and attached to orders via inclusion rules.",
    owner: "Max",
    createdAt: "2026-04-23",
    lastUpdated: "2026-04-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/846a3281a19376374044e49c2251d2c55e2bc1422751dd5afad5122a967e882c.png",
    creationTool: "cursor",
  },
];
